module.exports = __webpack_public_path__ + "img/50.10.pH.43f6ac55.png";